import React from 'react';
import {
    withStyles, Typography, Paper,
} from '@material-ui/core'
import DeviceIcon from './DeviceIcon';

const noop = () => 0;

class DeviceItem extends React.Component {

    static defaultProps = {
        selectDevice: noop,
        expanded: true,
    };

    constructor(props) {
        super(props);
        this.state = {
            selected: false,
        }
    }

    render() {
        const { classes, device, selectDevice, isSelected, expanded } = this.props;
        return (
            <div key={device.id} onClick={() => selectDevice(device.id)}
                 className={`${classes.deviceItem} deviceItem ${expanded ? 'expanded' : ''}`}>
                <div>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <DeviceIcon deviceName={device.title}/>
                    </div>
                    <Typography style={{
                        display: 'block', fontWeight: (isSelected === true) ? 'bold' : 'normal',
                        textDecorationLine: (isSelected === true) ? 'underline' : 'none'
                    }}
                                variant='subtitle2' align='center'>
                        {device.title}
                    </Typography>
                </div>
            </div>
        )
    }
}

const styles = theme => ({
    deviceItem: {
        '&.expanded': {
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            paddingTop: '5px',
            paddingBottom: '5px',
            marginBottom: '15px',
            cursor: 'pointer',
        }
    },
});

export default withStyles(styles, { withTheme: true })(DeviceItem)

function _DeviceItemInline({ classes, device }) {
    return (
        <div className={classes.itemHeader}>
            <DeviceIcon deviceName={device.title}/>
            <Typography color='primary' variant="subtitle1" noWrap={true}
                        className={classes.itemTitle}>
                {device.title}
            </Typography>
            <Paper elevation={0} className={classes.colorPaper}>
                <span style={{ width: 17, height: 17, backgroundColor: device.color.code, borderRadius: '50%' }}/>
                <Typography variant="subtitle2" align='center' noWrap={true}
                            className={classes.colorName}>
                    {device.color.name}
                </Typography>
            </Paper>
        </div>
    )
}

const inlineStyle = {
    itemHeader: {
        display: "flex",
        flexDirection: 'row',
        alignItems: 'center',
    },
    itemTitle: {
        marginLeft: '5px',
        marginRight: '10px',
        fontWeight: 'bold',
    },
    colorPaper: {
        display: 'inherit',
        backgroundColor: 'white',
        padding: '2.5px',
    },
    colorName: {
        fontSize: '12px',
        marginLeft: '3px'
    },
};

export const DeviceItemInline = withStyles(inlineStyle)(_DeviceItemInline)
